var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63636 8.1H8.18182V12.6H3.63636V8.1ZM14.5455 16.2H1.81818V6.3H14.5455V16.2ZM14.5455 1.8H13.6364V0H11.8182V1.8H4.54545V0H2.72727V1.8H1.81818C0.809091 1.8 0 2.61 0 3.6V16.2C0 16.6774 0.191558 17.1352 0.532533 17.4728C0.873508 17.8104 1.33597 18 1.81818 18H14.5455C15.0277 18 15.4901 17.8104 15.8311 17.4728C16.1721 17.1352 16.3636 16.6774 16.3636 16.2V3.6C16.3636 3.12261 16.1721 2.66477 15.8311 2.32721C15.4901 1.98964 15.0277 1.8 14.5455 1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarV2);
export default __webpack_public_path__ + "static/media/icon-calendar-v2.fcac7b23391ead87bb4e31a2becfa6f7.svg";
export { ForwardRef as ReactComponent };